import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Modal, Tabs } from "antd";
import MerchantLayout from "../../layout/MerchantLayout";
import {
  CustomerOrderInfo,
  SubscriptionInfo,
  UserInfo,
} from "../../../context";
import axios from "axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import MerchantAddtionalServices from "./list";
import _ from "lodash";
import MerchantForCheckout from "./for-checkout";
// import MerchantAddtionalServicesBooking from "./booking";
import MerchantForCheckoutBooking from "./booking";

const MerchantAdditional = () => {
  const [serviceList, setServiceList] = useState({
    data: [],
    ready: false,
  });
  const [activeServiceList, setActiveServiceList] = useState({
    data: [],
    ready: false,
  });
  // const [merchantOrderSaveList, setMerchantOrderSaveList] = useState({
  //   data: [],
  //   ready: false,
  // });
  const [bookingList, setBookingList] = useState({
    data: [],
    ready: false,
  });
  const [loading, setLoading] = useState(false);

  const merchantOrderSaveList = useContext(CustomerOrderInfo);
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const navigate = useNavigate();

  const items = [
    {
      key: "1",
      label: `Service Avail`,
      children: (
        <MerchantForCheckout
          merchantOrderSaveList={merchantOrderSaveList.additionalService}
          activeServiceList={activeServiceList}
          rerun={() => {
            merchantOrderSaveList.rerunAdditionalService();
            getMerchantOrderSaveListBooking();
          }}
          refresh={() => {
            getAddtionalServiceList();
            merchantOrderSaveList.rerunAdditionalService();
          }}
          loading={loading}
          setLoading={setLoading}
        />
      ),
    },
    {
      key: "2",
      label: `Booking`,
      children: (
        <MerchantForCheckoutBooking
          bookingList={bookingList}
          activeServiceList={activeServiceList}
          rerun={() => {
            merchantOrderSaveList.rerunAdditionalService();
            getMerchantOrderSaveListBooking();
          }}
          refresh={() => {
            getMerchantOrderSaveListBooking();
          }}
          loading={loading}
        />
      ),
    },
    {
      key: "3",
      label: `Service List`,
      children: (
        <MerchantAddtionalServices
          serviceList={serviceList}
          rerun={() => getAddtionalServiceList()}
          loading={loading}
          setLoading={setLoading}
        />
      ),
    },
  ];

  const getAddtionalServiceList = useCallback(() => {
    setLoading(true);
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/additional-service-list", { params })
      .then((response) => {
        setLoading(false);
        const data = response.data;
        const active = data.filter((data) => parseInt(data.status) === 1);
        setServiceList({ data, ready: true });
        if (active.length > 0) {
          setActiveServiceList({
            data: active,
            ready: true,
          });
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  // const getMerchantOrderSaveList = useCallback(() => {
  //   setLoading(true);
  //   var params = {
  //     user_id: userData.data.id,
  //     status: 0,
  //     orderby: "asc",
  //     order_category: "additional-service",
  //     allow_housekeeping: userData.data.usersmerpermission.find(
  //       ({ permission }) => permission === "allow-house-keeping"
  //     )
  //       ? "yes"
  //       : "no",
  //   };
  //   axios
  //     .get("user/merchant/customer-order-list", {
  //       params,
  //     })
  //     .then((response) => {
  //       setLoading(false);
  //       const res = _.chain(response.data)
  //         .groupBy((g) => g.transaction_id)
  //         .map((value, key) => ({
  //           transaction_id: key,
  //           data: value,
  //           customer_name: value[0].customer_name,
  //           created_at: value[0].created_at,
  //           table_no: value[0].table_no,
  //           service_category: value[0].service_category,
  //           started_date: value[0].started_date,
  //           ended_date: value[0].ended_date,
  //           service_type: value[0].service_type,
  //         }))
  //         .value();
  //       const res2 = _.orderBy(res, ["created_at"], ["desc"]);
  //       setMerchantOrderSaveList({ data: res2, ready: true });
  //     })
  //     .catch((error) => {
  //       console.log("ERROR: ", error);
  //     });
  // }, [userData.data.id]);

  const getMerchantOrderSaveListBooking = useCallback(() => {
    setLoading(true);
    var params = {
      user_id: userData.data.id,
      status: 0,
      orderby: "asc",
      order_category: "additional-service",
      allow_housekeeping: userData.data.usersmerpermission.find(
        ({ permission }) => permission === "allow-house-keeping"
      )
        ? "yes"
        : "no",
    };
    axios
      .get("user/merchant/customer-reserved-order-list", {
        params,
      })
      .then((response) => {
        setLoading(false);
        setBookingList({ data: response.data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getAddtionalServiceList();
    // getMerchantOrderSaveList();
    getMerchantOrderSaveListBooking();
  }, [
    getAddtionalServiceList,
    // getMerchantOrderSaveList,
    getMerchantOrderSaveListBooking,
  ]);

  return (
    <MerchantLayout>
      <Tabs defaultActiveKey="1" items={items} />

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        // open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </MerchantLayout>
  );
};

export default MerchantAdditional;
